import {useState} from 'react'
const Buscar = (props) => {  
    const [apellido, setApellido] = useState('')
    const [nombre, setNombre] = useState('')
    const [documento, setDocumento] = useState ('')
    const color_yaesta = 'grid grid-cols-3 px-2 text-sm text-green-600'
    const color_noesta = 'grid grid-cols-3 px-2 text-sm text-zinc-800'

    const validar = (e) => {
        if (( /^[0-9]+$/.test(e) && e.length<9) || e=== '')
            props.setDocumento(e)
    }

    const agregar = (e) => {
        const yaesta = props.elegidos.find(a => a.id ===e.id)
        if (yaesta===undefined)
            props.setElegidos(props.elegidos.concat(e))
    }

    const agregar_cobrar = (a) => {
        var ids = a.id.toString()
        if (a.pileta[0].cabeza) {
            ids +=',' + a.pileta[0].grupoIds 
            const datos = ids.split(',').map(Number)
            const final = datos.map(e => {
                return props.socios.find(t => t.id === e)
            })
            props.setElegidos(final)
        } else {
            if (a.pileta[0].grupoIds!=='') {
                const cabeza = props.socios.find(e => e.id===parseInt(a.pileta[0].grupoIds))
                agregar_cobrar(cabeza)
            } else
                props.setElegidos([a])
        }
    }
   
     return (<>
        <div className="grid grid-cols-3 text-lg  py-1">
            <div>
                Apellido
                <input 
                    className="w-20 p-1 ml-5"
                    type="text"
                    value={apellido}
                    onChange={e => setApellido(e.target.value)}
                />
            </div>
            <div>
                Nombre
                <input 
                    className="w-20 p-1 ml-5"
                    type="text"
                    value={nombre}
                    onChange={e => setNombre(e.target.value)}
                />
            </div>
            <div>
                Documento
                <input 
                    className="w-20 p-1 ml-5"
                    type="text"
                    value={documento}
                    onChange={e => validar(e.target.value)}
                />
            </div>
        </div>
        <ul className="overflow-y-auto cursor-pointer h-[39rem]">
        {props.socios.map(a => {
            if (props.cobrar && !a.pileta.length) return
            if (a.nombre.toLowerCase().includes((nombre).toLowerCase()) && a.apellido.toLowerCase().includes((apellido).toLowerCase()) && a.documento.includes((documento))) 
                return  (<>
                {!props.cobrar ?
                <li 
                    key={a.id} 
                    className={a.pileta.length ? color_yaesta : color_noesta}
                    onClick={!a.pileta.length ? () => agregar(a) : () => {}}
                >
                <div>{a.apellido}</div>
                <div>{a.nombre}</div>
                <div>{a.documento}</div>
                </li>
                    :
                <li 
                    key={a.id} 
                    className={color_noesta}
                    onClick={() => agregar_cobrar(a)}
                 >
                <div>{a.apellido}</div>
                <div>{a.nombre}</div>
                <div>{a.documento}</div>
                 </li>
                }
                 </>)
            })
        }
        </ul>
    </>)
}

export default Buscar